// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__uW5mW","checkboxCol":"Table_checkboxCol__1FoQa","emailCol":"Table_emailCol__2rhKg","actionCol":"Table_actionCol__3nqBb"};